import { useAuth } from "@/contexts/AuthContext";

// admin page path -> permission area (longest prefix wins; "/admin" exact = dashboard)
const PATH_AREAS = [
  ["/admin/leads", "leads"], ["/admin/applications", "applications"], ["/admin/resumes", "applications"],
  ["/admin/dealers", "dealers"], ["/admin/dealer-visits", "dealers"], ["/admin/announcements", "announcements"],
  ["/admin/locations", "locations"], ["/admin/verizon-sales", "dealer_sales"], ["/admin/blog", "blog"],
  ["/admin/gallery", "gallery"], ["/admin/knowledge-base", "knowledge_base"], ["/admin/training", "training"],
  ["/admin/inventory", "inventory"], ["/admin/marketplace-orders", "inventory"], ["/admin/chat", "chat"],
  ["/admin/deals", "deals"], ["/admin/reports/audit-log", "audit_log"], ["/admin/reports/dealer-visits", "dealers"],
  ["/admin/reports/resumes", "applications"], ["/admin/reports/inventory-removals", "inventory"], ["/admin/reports", "reports"],
  ["/admin/analytics", "dashboard"], ["/admin/pages", "settings_pages"], ["/admin/cities", "settings_city_pages"],
  ["/admin/state-images", "settings_city_pages"], ["/admin/seo", "settings_seo"], ["/admin/users", "users"],
];

export const SETTINGS_TAB_AREAS = {
  pages: "settings_pages", cities: "settings_city_pages", seo: "settings_seo", "keyword-templates": "settings_keywords",
  indexnow: "settings_indexnow", emails: "settings_email", "email-sending": "settings_gmail", commissions: "settings_commissions", users: "users", roles: "user_roles",
};

export const areaForPath = (path) => {
  if (path === "/admin" || path === "/admin/") return "dashboard";
  const hit = PATH_AREAS.filter(([p]) => path.startsWith(p)).sort((a, b) => b[0].length - a[0].length)[0];
  return hit ? hit[1] : null;
};

export const useAdminAccess = () => {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const perms = user?.permissions || {};
  const can = (area, level = "view") => {
    if (isAdmin || !area) return true;
    if (area.startsWith("vz_") && !["view", "manage"].includes(perms.dealer_sales)) return false;
    return perms[area] === "manage" || (level === "view" && perms[area] === "view");
  };
  return { can, isAdmin };
};
